import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import {useTranslation} from "react-i18next";
import getWorkshop from "../../utils/getWorkshop";
import {COUNTRY_CODE_SE} from "../../utils/country";

export const PAYMENT_METHOD_CASH = 1; //gotówka
export const PAYMENT_METHOD_TRANSFER = 2; //przelew
export const PAYMENT_METHOD_CARD = 3; //karta płatnicza
export const PAYMENT_METHOD_COMPENSATION = 4; //kompensata
export const PAYMENT_METHOD_BLIK = 5; //blik
export const PAYMENT_METHOD_CASH_ON_DELIVERY = 6; //za pobraniem
export const PAYMENT_METHOD_ON_LINE = 7; //płatność on-line
export const PAYMENT_METHOD_SWISH = 8; //SWISH - tylko dla Szwecji - TODO wymagany refactor metod płatności

function PaymentMethodSelect(props) {
  const { t } = useTranslation('payment_method');
  const [value, setValue] = React.useState(props.value);

  React.useEffect(() => setValue(props.value), [props.value]);

  const options = [
    {value: PAYMENT_METHOD_CASH, label: t(`common:payment_method.${PAYMENT_METHOD_CASH}`)},
    {value: PAYMENT_METHOD_TRANSFER, label: t(`common:payment_method.${PAYMENT_METHOD_TRANSFER}`)},
    {value: PAYMENT_METHOD_CARD, label: t(`common:payment_method.${PAYMENT_METHOD_CARD}`)},
    {value: PAYMENT_METHOD_COMPENSATION, label: t(`common:payment_method.${PAYMENT_METHOD_COMPENSATION}`)},
    {value: PAYMENT_METHOD_BLIK, label: t(`common:payment_method.${PAYMENT_METHOD_BLIK}`)},
    {value: PAYMENT_METHOD_CASH_ON_DELIVERY, label: t(`common:payment_method.${PAYMENT_METHOD_CASH_ON_DELIVERY}`)},
    {value: PAYMENT_METHOD_ON_LINE, label: t(`common:payment_method.${PAYMENT_METHOD_ON_LINE}`)},
  ];

  if(getWorkshop().workshopDetails.countryCode === COUNTRY_CODE_SE){
    options.push({value: PAYMENT_METHOD_SWISH, label: t(`common:payment_method.${PAYMENT_METHOD_SWISH}`)})
  }

  return <Select
    classNamePrefix="react-select"
    menuPortalTarget={document.body}
    placeholder="Metoda płatności"
    className="w-100"
    options={options}
    isClearable={props.isClearable}
    isSearchable={false}
    value={options.find(o => o.value === value)}
    onChange={option => props.onChange(option?.value ?? null)}
  />
}

PaymentMethodSelect.defaultProps = {
  isClearable: false,
};

PaymentMethodSelect.propTypes = {
  isClearable: PropTypes.bool,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default PaymentMethodSelect;
